.SDSInternalSpinner {
  animation: sds-spinner-rotate 1.4s linear infinite;
  display: inline-block;

  @keyframes sds-spinner-rotate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
}

// Respect reduced motion preference
@media (prefers-reduced-motion: reduce) {
  .SDSInternalSpinner {
    animation: none;

    // Show a static loading indicator instead
    &::after {
      content: '...';
      position: absolute;
      font-weight: bold;
    }
  }
}
